import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import Cleave from 'cleave.js/react';
import Helper from 'Helper';
import { API_BASE } from 'API';


const ModalPagamento = () => {
  const [value, setValue] = useState('');

  useEffect(() => {
    // Nenhum valor inicial necessário aqui, será definido ao abrir o modal
  }, []);

  const showAlert = (forma_cod, initialValue, anotherValue) => {
    const formattedValue = initialValue; // Formata o valor inicial
    swal({
      text: 'Digite um valor em '+anotherValue,
      content: {
        element: 'input',
        attributes: {
          type: 'text',
          id: 'cleave-input',
          value: formattedValue, // Define o valor inicial no input
        },
      },
      buttons: {
        cancel: {
          text: 'Fechar',
          value: null,
          visible: true,
          className: 'btn-danger btnDanger', // Adiciona a classe personalizada
          closeModal: true,
        },
        insert: {
            text: 'Salvar',
            value: 'insert',
            className: 'btnBlack', // Adiciona a classe personalizada
          },
      },
      closeOnClickOutside: false, // Evita fechar clicando fora
    }).then((buttonValue) => {
      if (buttonValue === 'insert' || buttonValue === 'balance') {
          let cleaveValue = document.getElementById('cleave-input').value;
        // Remover pontos de milhar
         
          let valorLimpo = cleaveValue;

          let saldo = valorLimpo.replace(/[^0-9.,]/g, "");

          // 2. Mantém só o último separador como decimal
          let partes = saldo.split(/[,\.]/);
          let decimal = partes.pop(); // último grupo vira decimal
          let inteiro = partes.join(""); // junta o resto sem separadores

          // 3. Junta no formato final
          let saldoFinal = inteiro + "." + decimal;

          //console.log(saldoFinal); // 1071.00

          // Substituir vírgula decimal por ponto
          valorLimpo = saldoFinal;
          const numericValue = cleaveValue;
          
          if(sessionStorage.getItem('md') == 'dev'){
            console.log('Envio Caixa:', API_BASE+"processaPgto.php?access_token="+sessionStorage.getItem("token")+"&cod_inscricao="+sessionStorage.getItem("cod_inscricao")+"&id_user="+sessionStorage.getItem('nome_usser')+"&cod_usser="+sessionStorage.getItem('cod_usser')+"&valor="+valorLimpo+"&cod_forma="+forma_cod);
          }
          fetch(API_BASE+"processaPgto.php?access_token="+sessionStorage.getItem("token")+"&cod_inscricao="+sessionStorage.getItem("cod_inscricao")+"&id_user="+sessionStorage.getItem('nome_usser')+"&cod_usser="+sessionStorage.getItem('cod_usser')+"&valor="+valorLimpo+"&cod_forma="+forma_cod)
                .then((response) => response.json())
                .then((resultado) => {
                    if(sessionStorage.getItem('md') == 'dev'){
                        console.log('Resposta processaPgto:', resultado);
                    }
                  if(resultado.cod_inscricao !=""){
                    if(undefined != resultado.saldo && null != resultado.saldo){
                      sessionStorage.setItem("saldo",resultado.saldo);
                      sessionStorage.setItem("total_inscricao",resultado.total_inscricao);
                      sessionStorage.setItem("pago",resultado.total_pago);
                      Helper.CalculaTotais();
                    }
                    swal('Inserido', `Valor inserido: R$ ${numericValue}`, 'success');       
                  }
                  else{
                   return false;   
                  }
              })
              .catch((error) => {
                  console.error(error);
                  return false; 
              });


         
         
      } else {
          return false;
      }
    });
  };
  
  return showAlert;
};

export default ModalPagamento;
